import React from 'react'
import ModalFormUI from '../../../../widgets/form/ModalFormUI'
import InputSelectSF from '../../../../widgets/form/InputSelectSF'
import SpinnerUI from '../../../../widgets/output/SpinnerUI'
import ErrorMessageUI from '../../../../widgets/form/ErrorMessageUI'

/**
 * DuplicateComplianceModalUI
 *
 * Modal for selecting a source loan and duplicating its CP or CS docs
 * into the current loan.
 *
 * Shows a dropdown with other loans in the same account, labelled as:
 *   "LRN00613388 - standard"
 *
 * If the user picks a loan with a different loanSubType, the backend
 * will return an error which is surfaced in the errorList.
 */
const DuplicateComplianceModalUI = ({
  context,
  loan,
  compliance,
  duplicateMode,
  onCancelClick,
  // Loans dropdown
  loanOptionList,
  accountLoansLoading,
  accountLoansErrorList,
  // Source loan selection
  sourceLoanId,
  onSourceLoanIdChange,
  sourceLoanIdError,
  setSourceLoanIdError,
  // Submission
  submitted,
  successMsg,
  errorList,
  setErrorList,
  onSubmit,
}) => {
  const typeLabel = compliance === 'cs' ? 'CS (Condition Subsequent)' : 'CP (Condition Precedent)'

  return (
    <ModalFormUI
      context={context}
      titleLabel={`Duplicate ${typeLabel} Documents`}
      buttonLabel='Duplicate'
      cancelLabel='Cancel'
      isOpen={duplicateMode}
      onRequestClose={onCancelClick}
      successMsg={successMsg}
      errorList={errorList}
      setErrorList={setErrorList}
      onSubmit={onSubmit}
      busy={submitted}
    >
      <p className='g_muted g_m_bottom_100' style={{ fontSize: '14px' }}>
        Select a previous loan from this account to copy its{' '}
        <strong>{typeLabel}</strong> documents into the current loan{' '}
        (<strong>{loan.loanRefNum}</strong>).
        The source loan must have the same loan subtype (
        <strong>{loan.loanSubType}</strong>).
      </p>

      {/* Show a spinner while the account loan list is loading */}
      {
        accountLoansLoading &&
        <SpinnerUI show={true} />
      }

      {/* Error loading the account loans list */}
      {
        !accountLoansLoading && accountLoansErrorList && accountLoansErrorList.length > 0 &&
        <ErrorMessageUI errorList={accountLoansErrorList} />
      }

      {/* Dropdown — only rendered once loans are loaded */}
      {
        !accountLoansLoading &&
        <InputSelectSF
          type='select'
          name='sourceLoanId'
          label='Select loan to duplicate from'
          required={true}
          value={sourceLoanId}
          onChange={onSourceLoanIdChange}
          optionList={loanOptionList}
          error={sourceLoanIdError}
          setError={setSourceLoanIdError}
        />
      }

      {
        !accountLoansLoading && loanOptionList.length === 0 && !accountLoansErrorList.length &&
        <p className='g_muted' style={{ fontSize: '13px' }}>
          No other loans found in this account.
        </p>
      }
    </ModalFormUI>
  )
}

export default DuplicateComplianceModalUI